import { render, staticRenderFns } from "./pro-plus-plan.vue?vue&type=template&id=33d06062&scoped=true&"
import script from "./pro-plus-plan.vue?vue&type=script&lang=js&"
export * from "./pro-plus-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d06062",
  null
  
)

export default component.exports